import styled from "styled-components";
import { COLORS, responsive, BREAKPOINTS } from "../../styles/constants.style";
import {
  fontWeightSemiBold,
  h3Regular,
} from "../typography/MuiTypography.style";

export const MuiTableWrapper = styled.div`
  .MuiTableCell-head {
    cursor: pointer;
  }

  .MuiTableCell-root.pinned-right {
    position: sticky;
    z-index: 2;
    right: 0;
    background: inherit;
    filter: drop-shadow(-4px 0px 4px rgba(56, 96, 151, 0.1));
  }

  /* Fix for sticky header + sticky column intersection */
  .MuiTableHead-root .MuiTableCell-root.pinned-right {
    z-index: 10;
    background-color: ${COLORS.primary_light_blue3};
  }

  /* Maintain background when column is sorted */
  .MuiTableHead-root .MuiTableCell-root.pinned-right.sort-enabled {
    background-color: ${COLORS.primary_light_blue4};
  }

  .form-header {
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiPaper-root.MuiTableContainer-root {
    border-radius: 0;
  }

  .MuiGrid2-root {
    width: 100%;
  }

  .MuiTable-root {
    .MuiTableHead-root .sort-enabled {
      background-color: ${COLORS.primary_light_blue4};
    }

    .MuiTableBody-root {
      .Mui-selected {
        background-color: ${COLORS.cirrus_black1} !important;
        border: 2px solid ${COLORS.cirrus_black6};
      }

      .MuiTableRow-root:nth-of-type(even) {
        background-color: ${COLORS.primary_light_blue1};

        .MuiTableCell-root.pinned-right {
          background-color: ${COLORS.primary_light_blue1};
        }
      }
      .MuiTableRow-root:nth-of-type(odd) {
        background-color: ${COLORS.cirrus_white};

        .MuiTableCell-root.pinned-right {
          background-color: ${COLORS.cirrus_white};
        }
      }

      /* Fix sticky column background for selected rows */
      .Mui-selected .MuiTableCell-root.pinned-right {
        background-color: ${COLORS.cirrus_black1} !important;
      }
      .row-label-value {
        max-width: 290px;
      }
      .MuiTableRow-root .MuiTableCell-root {
        border-bottom: 0;

        p {
          color: ${COLORS.cirrus_black10};
        }
        a h3.Link {
          text-decoration: underline;
          color: ${COLORS.primary_light_blue};
        }
        h3 {
          color: ${COLORS.cirrus_black10};
        }
      }
    }

    .MuiTableFooter-root {
      .MuiTableRow-root.MuiTableRow-footer {
        p.MuiTablePagination-selectLabel {
          margin-bottom: 4px;
        }
        p.MuiTablePagination-displayedRows {
          margin-bottom: 0;
        }

        .MuiInputBase-root.MuiTablePagination-input {
          border: 1px solid ${COLORS.cirrus_black4};
          border-radius: 8px;
          background-color: ${COLORS.cirrus_black1};
        }
        .MuiTablePagination-selectLabel {
          ${h3Regular}
        }

        .MuiTablePagination-toolbar .MuiTablePagination-displayedRows {
          flex: unset;
        }
      }
    }

    .MuiInputAdornment-root {
      margin: 0;
      color: ${COLORS.primary_light_blue};
    }

    .MuiInputBase-adornedStart {
      background: ${COLORS.cirrus_black1};
    }
  }

  .MuiTableRow-root.MuiTableRow-head.MuiTableRow-root {
    background-color: ${COLORS.primary_light_blue3};

    /* Make the column header row sticky at top */
    &:not(.no-background) {
      position: sticky;
      top: 0;
      z-index: 5;
    }

    /* Make the filter row sticky below the header row */
    &.no-background {
      background-color: ${COLORS.cirrus_white};
      position: sticky;
      top: 62px; /* Height of the first header row */
      z-index: 5;

      .MuiTableCell-root {
        padding: 16px 8px;

        & > div {
          margin-top: 0;
        }
      }

      /* Fix sticky column background in filter row */
      .MuiTableCell-root.pinned-right {
        background-color: ${COLORS.cirrus_white};
        z-index: 10;
      }
    }

    .MuiTableCell-root {
      padding: 13px 16px;
      white-space: nowrap;
      color: ${COLORS.cirrus_black};
    }
  }
  .css-oegngy-MuiInputBase-root-MuiTablePagination-select
    .MuiTablePagination-select {
    padding-right: 20px;
    padding-left: 0px;
  }

  .MuiTablePagination-menuItem {
    text-align: center;
  }

  .empty-table-cell {
    width: 100%;
  }

  .empty-table-box {
    display: flex;
    justify-content: center;

    ${responsive.MOBILE`
      justify-content: flex-start;
    `}
  }

  .mobile-footer {
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;

    .MuiTableFooter-root,
    .MuiTableRow-root,
    .MuiTableCell-root {
      display: block;
      width: 100%;
      padding: 0;
      margin: 0;
      border: none;
    }
  }

  .MuiTableRow-footer {
    position: relative;
    .MuiTablePagination-toolbar {
      .MuiTablePagination-spacer {
        flex: none;
      }
      .MuiTablePagination-displayedRows {
        display: flex;
        flex: 1;
        justify-content: end;
      }
    }

    /* Ensure footer cell uses full width without inner padding */
    .MuiTableFooter-root .MuiTableRow-footer > .MuiTableCell-root,
    & .MuiTableCell-root {
      ${responsive.MOBILE`
        padding-right: 0 !important;
        padding-left: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        width: 100% !important;
      `}
    }

    .goto-page-wrapper {
      display: flex;
      align-items: center;
      padding: 16px;
      position: absolute;
      right: 0;
      top: 0;
      white-space: nowrap;

      ${responsive.MOBILE`
        position: sticky;
        padding: 16px 8px 16px 0;
        white-space: normal;
        width: 100%;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        gap: 12px;
        box-sizing: border-box;
        align-self: stretch;

        .goto-controls {
        }
      `}

      .MuiTypography-root {
        margin-right: 8px;
        color: ${COLORS.cirrus_black_dark};
        ${responsive.MOBILE`
          margin-right: 0;
          margin-bottom: 0;
        `}
      }
      .submit-goto-page {
        padding: 10px 16px;
        height: auto;
        margin-left: 8px;
        ${responsive.MOBILE`
          margin-left: 0;
        `}
      }

      .goto-controls {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: nowrap;
        white-space: nowrap;
        gap: 8px;
        ${responsive.MOBILE`
          width: 100%;
        `}

        /* Ensure inline alignment of label/input/button even on mobile */
        > * {
          flex: 0 0 auto;
        }
        > div {
          /* wrapper emitted by FormController */
          margin-top: 0;
        }
        .submit-goto-page {
          margin-left: 8px;
          height: 40px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }

      > div {
        margin-top: 0;
        .MuiTextField-root {
          width: 40px;
          height: 40px;
          border-radius: 8px;

          .MuiInputBase-root {
            width: 40px;
            height: 40px;

            .MuiInputBase-input {
              padding: 10px 6px;
              text-align: center;
            }
          }
        }

        .hide-error .MuiFormHelperText-root {
          display: none;
        }
        .hide-error .MuiOutlinedInput-notchedOutline {
          border-color: ${COLORS.cirrus_red};
          border-width: 2px;
        }
      }

      .pagination-container {
        margin-right: 16px;
        ${responsive.MOBILE`
          width: 100%;
          margin: 0;
          display: flex;
          justify-content: center;
          
          .MuiPagination-ul {
            width: 100%;
            justify-content: space-between;
            flex-wrap: nowrap;
            padding: 0;
            
            li {
              flex: 1;
              max-width: 45%;
              margin: 0;
              
              &:first-child:last-child {
                max-width: 100%;
                text-align: center;
              }
            }
          }
        `}
      }

      .MuiPagination-root .MuiPagination-ul li button.MuiButtonBase-root {
        background-color: ${COLORS.cirrus_black1};
        width: 40px;
        height: 40px;
        ${h3Regular}
        line-height: 19.36px;
        color: ${COLORS.primary_light_blue};
        margin: 0px 4px;
        svg {
          height: 28px;
          width: 28px;
          color: ${COLORS.primary_light_blue};
        }
      }

      .MuiPagination-root
        .MuiPagination-ul
        li
        button.MuiButtonBase-root.Mui-selected {
        ${fontWeightSemiBold}
        background-color: ${COLORS.primary_light_blue2};
      }
    }
  }

  .MuiTablePagination-displayedRows,
  .MuiTablePagination-actions {
    display: none !important;
  }

  .cellWithMultipleEntries {
    vertical-align: top;
  }

  .editMode {
    opacity: 0.8;
    pointer-events: none;
    user-select: none;
  }

  .custom-header {
    padding: 5px 0px;
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
`;
